import CustomizableGeneric from './CustomizableGeneric';

class Product extends CustomizableGeneric {
  getTypeName = () => 'Product';

  getFields = () => ['image', 'offers', 'name'];
}

export default Product;
